import auth from 'src/router/middleware/authentification/auth.js'

const News = () => import('src/views/Channels/News/News.vue')
const NewsCreation = () => import('src/views/Channels/News/NewsCreation.vue')
const NewsDetails = () => import('src/views/Channels/News/NewsDetails.vue')
const NewsScheduledList = () => import('src/views/Channels/News/NewsScheduledList.vue')

export default [
  {
    path: '/news:voters_list?',
    component: News,
    name: 'feed',
    meta: {
      layout: 'sdui',
      middleware: [auth],
      group: 'feed',
      enableChildSwitch: true,
      transitionName: 'slide',
      headerText: 'global.headers.news',
      enableSwReload: true
    }
  },
  {
    path: '/news/scheduled',
    component: NewsScheduledList,
    name: 'scheduled-news',
    meta: {
      middleware: [auth],
      group: 'feed',
      headerText: 'global.headers.news_scheduled_list'
    }
  },
  {
    path: '/news/:id',
    component: NewsDetails,
    name: 'single-news',
    meta: {
      middleware: [auth],
      group: 'feed',
      headerText: 'global.headers.news_detail_page'
    }
  },
  {
    path: '/news/create',
    name: 'news-create',
    redirect: '/news/create/channelselection',
    meta: {
      isPublic: false,
      middleware: [auth],
      group: 'register',
      transitionPoint: 1,
      headerText: 'global.headers.create_news'
    }
  },
  {
    path: '/news/create/channelselection/:type?/:id?',
    component: NewsCreation,
    name: 'news-create-channel-selection',
    meta: {
      isPublic: false,
      middleware: [auth],
      group: 'register',
      transitionPoint: 1,
      headerText: 'global.headers.create_news_participants'
    }
  },
  {
    path: '/news/create/body',
    component: NewsCreation,
    name: 'news-create-body',
    meta: {
      isPublic: false,
      middleware: [auth],
      group: 'register',
      transitionPoint: 2,
      headerText: 'global.headers.create_news_content'
    }
  },
  {
    path: '/news/create/finish',
    component: NewsCreation,
    name: 'news-create-finish',
    meta: {
      isPublic: false,
      middleware: [auth],
      group: 'register',
      transitionPoint: 3,
      headerText: 'global.headers.create_news'
    }
  }
]
